import { memo } from 'react'

interface UserInfoProps {
  name: string
  initials: string
  onClick?: () => void
}

export const UserInfo = memo(({ name, initials, onClick }: UserInfoProps) => {
  const inner = (
    <>
      <div className="sidebar__initials">{initials}</div>
      <div className="sidebar__user-details">
        <span className="sidebar__name" title={name}>
          {name}
        </span>
      </div>
    </>
  )

  if (onClick) {
    return (
      <button type="button" className="sidebar__user" onClick={onClick}>
        {inner}
      </button>
    )
  }

  return <div className="sidebar__user">{inner}</div>
})

UserInfo.displayName = 'UserInfo'
